import { defineComponent as _defineComponent } from 'vue'
import CarouselArrowButton from 'JS/components/carousels/CarouselArrowButton.vue';
import ProgressSpinner from 'JS/components/ProgressSpinner.vue';
import { computed, ref } from 'vue';
import { SalesFlyerPageResource } from '../../types';

type PreloadImageFormat = keyof SalesFlyerPageResource['images']['large'];

/**
 * Marks the page's image as loaded and preloads the next/previous pages' images
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'SalesFlyerLightboxViewDesktop',
  props: {
    pages: null,
    currentPageIndex: null
  },
  emits: ["update:currentPageIndex"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'update:currentPageIndex', index: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	pages: SalesFlyerPageResource[],
	currentPageIndex: number;
}





const currentPage = computed(() => props.pages[props.currentPageIndex]);
const totalPages = computed(() => props.pages.length);

const pageControls = computed(() => ({
	previous: {
		props: {
			direction: 'previous' as const,
			'aria-disabled': props.currentPageIndex <= 0,
			'aria-label': 'Previous Page'
		},
		onClick: () => selectPage(props.currentPageIndex - 1),
	},
	next: {
		props: {
			direction: 'next' as const,
			'aria-disabled': props.currentPageIndex >= totalPages.value - 1,
			'aria-label': 'Next Page'
		},
		onClick: () => selectPage(props.currentPageIndex + 1),
	}
}));

function selectPage(index: number) {
	emit('update:currentPageIndex', Math.max(0, Math.min(totalPages.value - 1, index)));
}

const loadedImagesByPageId = ref<Record<number, boolean>>({});

function handleImageLoad(e: Event, pageId: number) {
	loadedImagesByPageId.value = {
		...loadedImagesByPageId.value,
		[pageId]: true,
	};

	if (!(e.target instanceof HTMLImageElement) || pageId !== currentPage.value.pageID) {
		return;
	}

	let preloadFormat: PreloadImageFormat;
	if (e.target.currentSrc.endsWith('.avif')) {
		preloadFormat = 'avif';
	} else if (e.target.currentSrc.endsWith('.webp')) {
		preloadFormat = 'webP';
	} else {
		preloadFormat = 'jpeg';
	}

	const previousPage = props.pages[props.currentPageIndex - 1];
	const nextPage = props.pages[props.currentPageIndex + 1];

	preloadPageImage(previousPage, preloadFormat);
	preloadPageImage(nextPage, preloadFormat);
}

/**
 * Preloads the given page's image in the given format, and marks it as loaded afterward
 */
function preloadPageImage(page: SalesFlyerPageResource | undefined, format: PreloadImageFormat) {
	if (!page || loadedImagesByPageId.value[page.pageID]) {
		return;
	}

	const img = new Image();
	img.onload = () => {
		loadedImagesByPageId.value = {
			...loadedImagesByPageId.value,
			[page.pageID]: true,
		};
	};
	img.src = page.images.large[format];
}

return { __sfc: true,props, emit, currentPage, totalPages, pageControls, selectPage, loadedImagesByPageId, handleImageLoad, preloadPageImage, CarouselArrowButton, ProgressSpinner }
}

})